import React from 'react';
import styled from 'styled-components';
import {
  primaryFont, wMedium, primaryHeadingColor, maxWidth, retina,
} from 'Utils/utilsStyle';

type Props = {
  dataList?: string[]
};

const defaultProps = {
  dataList: [''],

};

const Wrapper = styled.div`
  .heading {
    color: ${primaryHeadingColor};
    font-family: ${primaryFont};
    font-size: 20px;
    font-weight: ${wMedium};
    letter-spacing: -0.45px;
    line-height: 25px;
    margin-bottom: 8px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 15px;
      line-height: 18px;
    }
  }
  .communication-tips-li {
    padding-left: 20px;
  }
  .list-item {
    color: #67696A;
    font-family: ${primaryFont};
    font-size: 16px;
    font-weight: ${wMedium};
    letter-spacing: -0.33px;
    line-height: 24px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 14px;
      line-height: 28px;
    }
  }
`;

const CommunicationTips = function CommunicationTips({ dataList }: Props) {
  return (
    <Wrapper>
      <div>
        <h3 className="heading">
          Communication Tips:
        </h3>
        <ul className="communication-tips-li">
          {dataList?.map((item) => (
            <li key={item} className="list-item">{item}</li>
          ))}
        </ul>
      </div>
    </Wrapper>
  );
};

CommunicationTips.defaultProps = defaultProps;

export default CommunicationTips;
